import React from "react";
import PropTypes from "prop-types";
import ReactWordcloud from 'react-wordcloud';
import './index.scss';

class WordCloud extends React.PureComponent {
    render() {
        const { data } = this.props;
        return (
            <ReactWordcloud options={{
                rotations: 2,
                rotationAngles: [0, 0],
                fontSizes: [10, 40],

                transitionDuration: 0,
                tooltipOptions: {
                    theme: 'dark',
                    arrow: true
                }
            }}
                minSize={[400, 400]}
                words={data} />
        );
    }
}

WordCloud.propTypes = {
    data: PropTypes.array.isRequired
};

export default WordCloud;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/analytics/queryanalytics/components/wordcloud/index.js